export default __webpack_public_path__ + "static/media/Tamil_Nadu.9c2a4e8e.svg";